module.exports = __webpack_public_path__ + "img/mastercard.4a69f461.png";